import styled from 'styled-components';

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;

  background-color: transparent;
  color: rgb(107, 119, 140);
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;
